import ReactOnRails from 'react-on-rails';
import OlivIAApp from '../bundles/OlivIA/components/OlivIAApp';

ReactOnRails.register({
  OlivIAApp,
});
